import { DataTableOptionsInterface } from '@/types';
import { defineStore } from 'pinia';

export const useSurveyCampaignStore = defineStore('surveyCampaign', {
	state: () => ({
		selectedCampaign: null as string | null,
		dataTableOptions: null as DataTableOptionsInterface | null,
		totalCount: 0
	}),

	getters: {
		getSelectedCampaign: (state): string | null => state.selectedCampaign
	},

	actions: {
		setSelectedCampaign(ref: string | null) {
			this.selectedCampaign = ref;

			if (null !== this.dataTableOptions) {
				this.dataTableOptions.page = 1;
			}
		},
		clearSelectedCampaign() {
			this.selectedCampaign = null;
		}
	},
	persist: {
		storage: localStorage,
		paths: ['selectedCampaign', 'totalCount', 'dataTableOptions']
	}
});
